import { render, staticRenderFns } from "./DashboardAccounts.vue?vue&type=template&id=53735eb0&scoped=true"
import script from "./DashboardAccounts.vue?vue&type=script&lang=js"
export * from "./DashboardAccounts.vue?vue&type=script&lang=js"
import style0 from "./DashboardAccounts.vue?vue&type=style&index=0&id=53735eb0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53735eb0",
  null
  
)

export default component.exports